<template>
  <div class="order-dialog" @contextmenu.stop>
    <el-dialog
      title="功能显示隐藏设置"
      width="500px"
      height="600px"
      top="calc( 50vh - 150px )"
      custom-class="order-dialog"
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :handleCancel="handleCancel"
    >
      <div class="title">
        <div>功能名称</div>
        <div>是否显示</div>
      </div>
      <div class="button-list">
        <div class="button-item">
          <div class="name">登录：</div>
          <el-radio-group v-model="buttonList.login">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </div>
        <div class="button-item">
          <div class="name">收藏：</div>
          <el-radio-group v-model="buttonList.collect">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </div>
        <div class="button-item" v-if="currentModule === 'book'">
          <div class="name">缩略图：</div>
          <el-radio-group v-model="buttonList.thumbnail" :disabled="paperStyle">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </div>
        <div class="button-item" v-if="currentModule === 'book'">
          <div class="name">目录：</div>
          <el-radio-group v-model="buttonList.catalog" :disabled="paperStyle">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </div>
        <div class="button-item" v-if="currentModule != 'bookLib' && currentModule != 'bookShelf'">
          <div class="name">听文章：</div>
          <el-radio-group v-model="buttonList.tingWen">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </div>
        <div class="button-item" v-if="currentModule != 'bookLib' && currentModule != 'bookShelf'">
          <div class="name">AI朗读按钮：</div>
          <el-radio-group v-model="buttonList.aiRead">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </div>
        <!-- <div class="button-item" v-if="currentModule === 'book'">
          <div class="name">自动翻页：</div>
          <el-radio-group v-model="buttonList.atuo" :disabled="paperStyle">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </div> -->
        <div class="button-item" v-if="currentModule === 'book'">
          <div class="name">右键菜单：</div>
          <el-radio-group v-model="buttonList.rightKeyMenu">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </div>
        <div class="button-item" v-if="currentModule === 'book'">
          <div class="name">两侧翻页按钮：</div>
          <el-radio-group v-model="buttonList.bothSidePageBtn">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </div>
        <div class="button-item">
          <div class="name">搜索：</div>
          <el-radio-group v-model="buttonList.search">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </div>
        <div class="button-item" v-if="isPaper && currentModule != 'bookLib' && currentModule != 'bookShelf'">
          <div class="name">全站搜索：</div>
          <el-radio-group v-model="buttonList.searchArticle">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </div>
        <div class="button-item">
          <div class="name">分享：</div>
          <el-radio-group v-model="buttonList.share">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </div>
        <div class="button-item" v-if="currentModule === 'book'">
          <div class="name">帮助：</div>
          <el-radio-group v-model="buttonList.help" :disabled="paperStyle">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </div>
        <div class="button-item" v-if="currentModule === 'bookLib' || currentModule === 'bookShelf'">
          <div class="name">鼠标悬停二维码：</div>
          <el-radio-group v-model="buttonList.hoverQRcode">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </div>
        <div class="button-item" v-if="currentModule === 'bookLib' || currentModule === 'bookShelf'">
          <div class="name">PC端作品名称：</div>
          <el-radio-group v-model="buttonList.pctitle">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="default-edit-footer" id="edit-footer">
        <div class="edit-footer-item right" @click="handleCancel()">取消</div>
        <div class="edit-footer-item left" @click="save()">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ButtonSet',
  data() {
    return {
      dialogVisible: false,
      buttonList: {}
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        let obj = { ...this.displayOrNot }
        this.buttonList = obj
      }
    }
  },
  computed: {
    displayOrNot: {
      get: function() {
        return this.$store.state.config[this.currentModule + 'Obj'].displayOrNot
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_DISPLAY_OR_NOT_SHELF', { type: this.currentModule + 'Obj', displayOrNot: value })
      }
    },
    paperStyle() {
      return !!this.$store.state.config.paperStyle
    }
  },
  props: {
    currentModule: {
      type: String,
      default: 'book'
    },
    isPaper: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    console.log(this.displayOrNot)
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    save() {
      this.displayOrNot = { ...this.buttonList }
      console.log(this.displayOrNot)

      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.order-dialog {
  .title {
    display: flex;
    justify-content: space-evenly;
    background-color: #f4f4f4;
    height: 23px;
    line-height: 23px;
    font-weight: 600;
    color: #515151;
    div {
      width: 50%;
      text-align: center;
    }
  }
  .button-list {
    .button-item {
      display: flex;
      justify-content: space-evenly;
      height: 30px;
      line-height: 30px;
      .name {
        width: 50%;
        text-align: center;
      }
      .el-radio-group {
        width: 50%;
        text-align: center;
        .el-radio {
          height: 30px;
          line-height: 30px;
        }
      }
    }
  }
  .default-edit-footer {
    height: 50px;
    line-height: 36px;
    font-size: 14px;
    padding-top: 10px;
    background-color: #ffffff;
    text-align: center;

    .edit-footer-item {
      cursor: pointer;
      display: inline-block;
      height: 36px;
      border: 1px solid #df5813;
      text-align: center;
      width: 100px;
      &.left {
        background-color: #df5813;
        color: #fff;
      }
      &.right {
        margin-right: 30px;
      }
    }
  }
}
</style>
